import { Link, useLocation } from 'react-router-dom';
import { PATHS } from '../../../constants/Paths';

export default function HeartbeatNavigation() {
	const { pathname } = useLocation();
	const notes = pathname === PATHS.HEARTBEAT_NOTES;
	return <nav aria-label="Heartbeat" className="mb-5 flex gap-5 border-b border-border text-sm font-medium">
		{[{ to: PATHS.HEARTBEAT, label: 'Pulses', active: !notes }, { to: PATHS.HEARTBEAT_NOTES, label: 'Account notes', active: notes }].map(({ to, label, active }) => <Link key={to} to={to} aria-current={active ? 'page' : undefined} className={`border-b-2 py-3 focus-visible:outline-brand-600 ${active ? 'border-brand-600 text-brand-600' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>{label}</Link>)}
	</nav>;
}
